// import './vuetify'
import './veeValidate'
import './vueSnotify'
import './vueSweetAlert'
import './vueMoney'
import './vueFilters'
import './vueProgressBar'

// 🔄 Loading Service - Sistema otimizado
import { LoadingPlugin } from '@/services/loadingService'
import Vue from 'vue'

// 🔌 Registrar LoadingPlugin
Vue.use(LoadingPlugin)
